/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-contract
 * OpenAPI spec version: 1.0.0
 */

/**
 * Contract lifecycle status
 */
export type ContractLifecycleStatus =
  (typeof ContractLifecycleStatus)[keyof typeof ContractLifecycleStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractLifecycleStatus = {
  active: "active",
  in_collection_period: "in_collection_period",
  inactive: "inactive",
  init: "init",
  terminated: "terminated",
  to_be_terminated: "to_be_terminated",
} as const;
